import ChatBox from "./ChatBox";
import { ChatBoxType } from "./ChatBox";
import SystemPatientResults from "./SystemPatientResults";

export default ChatBox;
export type { ChatBoxType };
export { SystemPatientResults };